import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-1 max-w-full" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-red-600 truncate whitespace-nowrap"
}
const _hoisted_3 = { class: "w-full space-y-1" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "block w-32" }

import AppButton from "@/components/app/AppButton.vue";
import { reactive, ref } from "vue";
import { useFetch } from "@vueuse/core";
import {
    ExclamationCircleIcon,
    CheckCircleIcon,
} from "@heroicons/vue/24/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterForm',
  props: ["color"],
  setup(__props) {


const email = ref("");

const {
    isFinished,
    isFetching,
    error,
    execute: subscribe,
} = useFetch(`/api/subscribe`, { immediate: false })
    .post(reactive({ email }))
    .json();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(subscribe) && _unref(subscribe)(...args)), ["prevent"])),
    class: "space-y-4 w-full"
  }, [
    (_unref(isFinished))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex items-start w-full space-x-2 rounded p-4 border-2 border-dotted", 
                _unref(error)
                    ? 'text-red-600 border-red-600'
                    : 'text-green-600 border-green-600'
            ])
        }, [
          (_unref(error))
            ? (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
                key: 0,
                class: "w-6 h-6 block"
              }))
            : (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                key: 1,
                class: "w-6 h-6 block"
              })),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h4", null, _toDisplayString(_unref(error)
                            ? "The following Error occured:"
                            : "Congratulations! Your subscription was successful"), 1),
            (_unref(error))
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(error)), 1))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        required: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        type: "email",
        id: "email",
        placeholder: "Your Email",
        class: "w-full block h-12 bg-neutral-900 rounded px-4 border border-neutral-800 placeholder-neutral-400 focus:border-neutral-50 !ring-0 !outline-none"
      }, null, 512), [
        [_vModelText, email.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AppButton, {
        disabled: _unref(isFetching),
        type: "submit",
        color: __props.color,
        size: "sm"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(isFetching)
                        ? "Loading"
                        : _unref(error)
                        ? "Try Again"
                        : "Join Newsletter"), 1)
        ]),
        _: 1
      }, 8, ["disabled", "color"])
    ])
  ], 32))
}
}

})